import type { IBaseButtonProps } from '@cian/ui-kit/button/types';
import { ILinkProps, useDeviceType } from '@cian/ui-kit';
import { DEFAULT_LINK_BUTTON_PROPS } from 'shared/constants/link-button-defaults';

export type LinkButtonProps = Pick<IBaseButtonProps, 'size' | 'fullWidth'> & Pick<ILinkProps, 'target' | 'rel'>;

export function useLinkButtonProps(): LinkButtonProps {
  const device = useDeviceType();
  const size: IBaseButtonProps['size'] = device === 'phone' ? 'M' : 'L';

  return { ...DEFAULT_LINK_BUTTON_PROPS, size };
}
